const options = {
    fontFamily: [
        {
            id: 1,
            label: "'Yuji Mai', serif",
            value: "'Yuji Mai', serif",
            url: 'https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap'
        },
        {
            id: 2,
            label: "'NotoSansJP', sans-serif",
            value: "'NotoSansJP', sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
        },
        {
            id: 3,
            label: "'Hachi Maru Pop', cursive",
            value: "'Hachi Maru Pop', cursive",
            url: 'https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap'
        },
        {
            id: 4,
            label: 'Noto Serif JP',
            value: 'Noto Serif JP',
            url: ''
        },
        {
            id: 5,
            label: 'M PLUS 1p',
            value: 'MPLUS1p',
            url: ''
        },
        {
            id: 6,
            label: 'Sawarabi Gothic',
            value: 'SawarabiGothic',
            url: ''
        },
        {
            id: 7,
            label: 'Zen Old Mincho',
            value: "'ZenOldMincho'",
            url: ''
        }
    ],
    units: [
        { label: 'px(ピクセル)', value: 'px' },
        { label: 'em(フォント高)', value: 'em' },
        { label: 'ex(小文字xのフォント高)', value: 'ex' },
        { label: 'pt(ポイント)', value: 'pt' },
        { label: 'pc(パイカ=12ポイント)', value: 'pc' },
        { label: 'mm(ミリメートル)', value: 'mm' },
        { label: 'cm(センチメートル)', value: 'cm' },
        { label: 'in(インチ)', value: 'in' },
        { label: '%(パーセント)', value: '%' }
    ],
    unitsNotIncludePercent: [
        { label: 'px(ピクセル)', value: 'px' },
        { label: 'em(フォント高)', value: 'em' },
        { label: 'ex(小文字xのフォント高)', value: 'ex' },
        { label: 'pt(ポイント)', value: 'pt' },
        { label: 'pc(パイカ=12ポイント)', value: 'pc' },
        { label: 'mm(ミリメートル)', value: 'mm' },
        { label: 'cm(センチメートル)', value: 'cm' },
        { label: 'in(インチ)', value: 'in' }
    ],
    unitsIncludeAuto: [
        { label: 'px(ピクセル)', value: 'px' },
        { label: 'em(フォント高)', value: 'em' },
        { label: 'ex(小文字xのフォント高)', value: 'ex' },
        { label: 'pt(ポイント)', value: 'pt' },
        { label: 'pc(パイカ=12ポイント)', value: 'pc' },
        { label: 'mm(ミリメートル)', value: 'mm' },
        { label: 'cm(センチメートル)', value: 'cm' },
        { label: 'in(インチ)', value: 'in' },
        { label: '%(パーセント)', value: '%' },
        { label: 'auto(自動調整)', value: 'auto' }
    ],
    unitsIncludeAutoNotPercent: [
        { label: 'px(ピクセル)', value: 'px' },
        { label: 'em(フォント高)', value: 'em' },
        { label: 'ex(小文字xのフォント高)', value: 'ex' },
        { label: 'pt(ポイント)', value: 'pt' },
        { label: 'pc(パイカ=12ポイント)', value: 'pc' },
        { label: 'mm(ミリメートル)', value: 'mm' },
        { label: 'cm(センチメートル)', value: 'cm' },
        { label: 'in(インチ)', value: 'in' },
        { label: 'auto(自動調整)', value: 'auto' }
    ],
    headingStyles: [
        { label: '黒丸(disc)', value: 'disc' },
        { label: '白丸(circle)', value: 'circle' },
        { label: '四角(square)', value: 'square' },
        { label: 'なし(none)', value: 'none' }
    ],
    directions: [
        { label: '無指定', value: 'none' },
        { label: '左', value: 'left' },
        { label: '中央', value: 'center' },
        { label: '右', value: 'right' }
    ],
    directionsvertical: [
        { label: '無指定', value: 'none' },
        { label: '上', value: 'top' },
        { label: '中央', value: 'center' },
        { label: '下', value: 'bottom' }
    ],
    layoutAlignments: [
        {
            label: '左寄せ',
            value: 'align_left'
        },
        {
            label: '中央揃え',
            value: 'align_center'
        },
        {
            label: '右寄せ',
            value: 'align_right'
        },
        {
            label: '幅100%',
            value: 'width_100_percent'
        }
    ],
    blockAlignments: [
        {
            label: '左寄せ',
            value: 'align_left'
        },
        {
            label: '中央揃え',
            value: 'align_center'
        },
        {
            label: '右寄せ',
            value: 'align_right'
        }
    ],
    blockAlignmentsVertical: [
        {
            label: '上寄せ',
            value: 'align_top'
        },
        {
            label: '中央揃え',
            value: 'align_center'
        },
        {
            label: '下寄せ',
            value: 'align_bottom'
        }
    ],
    borderTypes: [
        {
            label: '非表示(none)',
            value: 'none'
        },
        {
            label: '実線(solid)',
            value: 'solid'
        },
        {
            label: '二重線(double)',
            value: 'double'
        },
        {
            label: '点線(dotted)',
            value: 'dotted'
        },
        {
            label: '破線(dashed)',
            value: 'dashed'
        },
        {
            label: '全体が凹(inset)',
            value: 'inset'
        },
        {
            label: '全体が凸(outset)',
            value: 'outset'
        },
        {
            label: '枠線が凹(groove)',
            value: 'groove'
        },
        {
            label: '枠線が凸(ridge)',
            value: 'ridge'
        }
    ]
};
const configs = {
    configFieldTitle: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorCustomMess: '',
        errorField: 'ページタイトル',
        valueSync: '',
        typesValidate: ['max100']
    },
    configFieldSelectFont: {
        trackBy: 'value',
        label: 'label',
        isRemove: true,
        loading: false
    },
    configFieldFontSize: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '文字サイズ',
        errorCustomMess: '',
        valueSync: '',
        min: 1,
        max: 100,
        typesValidate: ['limit-input']
    },
    configFieldTableWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: 'テーブル幅',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 2000,
        typesValidate: ['max255', 'limit-input']
    },
    configFieldQuestionWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '質問欄',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 2000,
        typesValidate: ['limit-input']
    },
    configFieldAnswerWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '回答欄',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 2000,
        typesValidate: ['limit-input']
    },
    configFieldTableTopWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '上',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldTableBottomWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '下',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldTableLeftWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '左',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldTableRightWidth: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '右',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldLineThickness: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '太さ',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldCellSpacing: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '間隔',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldCellMargin: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: '余白',
        errorCustomMess: '',
        valueSync: '',
        min: 0,
        max: 1000,
        typesValidate: ['limit-input']
    },
    configFieldFontSizeError: {
        isNumber: true,
        isMaxLength: false,
        error: false,
        errorField: 'エラー文字サイズ',
        errorCustomMess: '',
        valueSync: '',
        min: 1,
        max: 100,
        typesValidate: ['max255', 'limit-input']
    },
    configFieldSelectUnits: {
        trackBy: 'value',
        label: 'label',
        isRemove: true,
        loading: false,
        error: false,
        errorField: '',
        errorMsg: ''
    },
    configFieldColor: {
        error: false,
        placeholder: '#',
        maxlength: 7
    },
    configFieldSelectHeadingStyles: {
        trackBy: 'value',
        label: 'label',
        isRemove: true,
        loading: false,
        error: false,
        errorField: '',
        errorMsg: ''
    },
    configFieldSelectDirection: {
        trackBy: 'value',
        label: 'label',
        isRemove: true,
        loading: false,
        error: false,
        errorField: '',
        errorMsg: ''
    },
    configFieldSelectBorderType: {
        trackBy: 'value',
        label: 'label',
        isRemove: true,
        loading: false,
        error: false,
        errorField: '',
        errorMsg: ''
    }
};

export { configs, options };
